import type { PermissionKey } from '@lp/contracts';
import { Blocks, Building2, ClipboardCheck, Gauge, Globe, History, Home, LayoutDashboard, Network, Package, ScrollText, Settings, Smartphone, Ticket, Trophy, Users, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** the phase that builds it (docs/45); shown greyed with the number, not a link */
  phase?: number;
  /** a company user sees it with read on any of these (Phase 9) */
  anyOf?: PermissionKey[];
  /** only a user of the company itself, not of one of its accounts */
  companyLevel?: boolean;
}

/**
 * The Command Center — the Super Admin's whole menu (master prompt §19). Nothing else. A client's own screens are reached from that
 * client's page, never from here.
 */
export const COMMAND_NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/clients', label: 'Clients', icon: Building2 },
  { to: '/products', label: 'Products', icon: Package },
  { to: '/results', label: 'Results', icon: Trophy },
  { to: '/packages', label: 'Packages', icon: Blocks },
  { to: '/templates', label: 'Templates', icon: ClipboardCheck },
  { to: '/domains', label: 'Domains', icon: Globe },
  { to: '/releases', label: 'Releases', icon: Smartphone },
  { to: '/health', label: 'System Health', icon: Gauge },
  { to: '/audit', label: 'Audit', icon: ScrollText },
];

/** a company user's own console (Phase 9): only what its permissions allow is shown — the server refuses the rest anyway */
export const COMPANY_NAV: NavItem[] = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/hierarchy', label: 'Hierarchy', icon: Network, anyOf: ['accounts', 'reports'] },
  { to: '/tickets', label: 'Tickets', icon: Ticket, anyOf: ['tickets'] },
  { to: '/products', label: 'Products', icon: Package, anyOf: ['products'] },
  { to: '/settings', label: 'Settings', icon: Settings, anyOf: ['settings'] },
  { to: '/staff', label: 'Staff', icon: Users, anyOf: ['staff'] },
  { to: '/activity', label: 'Activity', icon: History, anyOf: ['staff'], companyLevel: true },
];
